import Button from '~components/ui/button'
import Header from './header'

type SmartSearchErrorProps = {
  onRetry: () => void
}

const SmartSearchError = ({ onRetry }: Readonly<SmartSearchErrorProps>) => {
  return (
    <>
      <Header />
      <div className="my-4 flex min-h-[252px] flex-col items-center justify-center flex-gap-y-4 px-5 py-6">
        <img
          src={`${import.meta.env.VITE_STATIC_RES}/img/error_dog.webp`}
          width={138}
          height={130}
          alt="error"
        />
        <div className="text-primary-600 text-headline-3">Internal Server Error</div>
        <p className="text-center text-primary-600 text-body-2 lg:whitespace-pre-line lg:text-body-3">
          {`We could not perform your request due to a technical issue\non our end or an unknown error.`}
          <br />
          <br />
          Please try again. Contact Help & Support if this issue continues.
        </p>
        <Button className="mt-2 w-fit" priority="secondary" onClick={onRetry}>
          Retry
        </Button>
      </div>
    </>
  )
}

export default SmartSearchError
